module.exports = __webpack_public_path__ + "static/media/primark.fd01f8e3.jpg";